// From inc/ directory
import "./inc/map_search.js";
import "./inc/read_more.js";
import "./inc/retail_user.js";

// Formerly in vendor.footer.js
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

const OriginalSwiper = window.Swiper;
const SWIPER_GLOBAL_DEFAULTS = {
    keyboard: {
        enabled: true,
        onlyInViewport: true,
    },
    a11y: true,
};

window.Swiper = function(container, options = {}) {
    const mergedOptions = deepMerge(SWIPER_GLOBAL_DEFAULTS, options);
    return new OriginalSwiper(container, mergedOptions);
};

Object.setPrototypeOf(window.Swiper, OriginalSwiper);
Object.assign(window.Swiper, OriginalSwiper);

function deepMerge(target, source) {
    const result = { ...target };
    for (const key in source) {
        if (source.hasOwnProperty(key)) {
            if (typeof source[key] === 'object' && source[key] !== null && !Array.isArray(source[key])) {
                if (typeof target[key] === 'object' && target[key] !== null && !Array.isArray(target[key])) {
                    result[key] = deepMerge(target[key], source[key]);
                } else {
                    result[key] = { ...source[key] };
                }
            } else {
                result[key] = source[key];
            }
        }
    }
    return result;
}

// =============================================================================
// get the sticky element
// const stickyElm = document.querySelector('.main-navbar')

// const observer = new IntersectionObserver(
//   ([e]) => e.target.classList.toggle('stuck', e.intersectionRatio < 1),
//   {threshold: [1]}
// );

// observer.observe(stickyElm)

// =============================================================================
// Trigger Tabs By Hash

var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl);
  var hash = '#' + triggerEl.href.split("#")[1];
  var tabBtn = document.querySelector( hash + "-tab");

  triggerEl.addEventListener("click", function (event) {
    event.preventDefault();
    tabBtn.click();
  })
})

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

tooltipTriggerList.forEach(function (tooltipTriggerEl) {
  new bootstrap.Tooltip(tooltipTriggerEl);
})


// =============================================================================
// == Split String =============

function splitStringByBreak(element) {

    // Split the string into words
    var pieces = element.innerHTML.split(/<br\s*\/?>/, 2);

    // Initialize arrays for the first and second halves
    var isTwoParts = pieces[1];
    var firstHalf = [];
    var secondHalf = [];

    if(isTwoParts){
        var firstHalf = [pieces[0]];
        var secondHalf = [pieces[1]];

        // Join the halves back into strings
        var first = firstHalf.join(' ');
        var last = secondHalf.join(' ');

        element.innerHTML = '<span class="first-part"> ' + first + '</span><span class="second-part"> ' + last + '</span>';
    }
    else {
        var firstHalf = [pieces[0]];
        var first = firstHalf.join(' ');

        element.innerHTML = '<span class="second-part"> ' + first + '</span>';
    }
}

var splitStrings = document.querySelectorAll(".split-string");
splitStrings.forEach(x => splitStringByBreak(x));

// =============================================================================
// == Focus on Search Open =============

const searchModal = document.getElementById('search-modal')
const searchInput = document.getElementById('modal-search')

if (searchModal && searchInput) {
    searchModal.addEventListener('shown.bs.modal', () => {
        searchInput.focus()
    })
}

// =============================================================================
// == Offcanvas =============

const mainNavOffcanvas = document.getElementById('main-nav');
const offcanvasSearchInput = document.getElementById('offcanvas-search');

if (mainNavOffcanvas) {
    // Bootstrap adds overflow:hidden to <body> when the offcanvas opens,
    // which interacts badly with sticky-top on the parent <nav> and causes
    // a scroll jump. Undo it immediately each time Bootstrap applies it.
    const bodyObserver = new MutationObserver(() => {
        if (document.body.style.overflow === 'hidden') {
            document.body.style.overflow = '';
        }
        if (document.body.style.paddingRight) {
            document.body.style.paddingRight = '';
        }
    });

    mainNavOffcanvas.addEventListener('show.bs.offcanvas', () => {
        bodyObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['style']
        });
    });

    mainNavOffcanvas.addEventListener('hidden.bs.offcanvas', () => {
        bodyObserver.disconnect();
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        // Bootstrap's focus restoration fires after this event and triggers an
        // unintended smooth scroll (scroll-behavior: smooth on :root + scroll-padding-top
        // on html causes scrollIntoView on the sticky toggler to animate toward y:0).
        // Capture position now and restore it on the next frame after focus fires.
        const savedY = window.scrollY;
        document.documentElement.style.scrollBehavior = 'auto';
        requestAnimationFrame(() => {
            window.scrollTo(0, savedY);
            document.documentElement.style.scrollBehavior = '';
        });
    });

    if (offcanvasSearchInput) {
        mainNavOffcanvas.addEventListener('shown.bs.offcanvas', () => {
            offcanvasSearchInput.focus();
        });
    }
}

// =============================================================================
// == Nav =============

const nav = document.querySelector('.main-navbars');
const topbar = document.getElementById('site-topbar');
let topbarDismissed = false;

if (topbar) {
    topbar.addEventListener('closed.bs.alert', () => {
        topbarDismissed = true;
        update();
    });
}

const NAV_BREAKPOINT = 1330;

const update = () => {
    const isDesktop = window.innerWidth >= NAV_BREAKPOINT;
    const topbarHeight = isDesktop && !topbarDismissed && topbar && topbar.offsetParent !== null ? topbar.offsetHeight : 0;
    const offset = isDesktop ? Math.max(topbarHeight - window.scrollY, 0) : 0;
    document.documentElement.style.setProperty('--topbar-offset', offset + 'px');

    if (nav) {
        nav.classList.toggle('sticky', isDesktop && window.scrollY > topbarHeight);
    }
};

const subnav = document.getElementById('subnav');

const setNavHeights = () => {
    if (nav) {
        document.documentElement.style.setProperty('--nav-height', nav.offsetHeight + 'px');
    }
    if (subnav) {
        document.documentElement.style.setProperty('--subnav-height', subnav.offsetHeight + 'px');
    }
};

if (nav) {
    setNavHeights();
    window.addEventListener('resize', setNavHeights);
    nav.addEventListener('transitionend', setNavHeights);
}

const hcmNotices = document.querySelectorAll('.oi-hcm-notice, .oi-ccpa-notice');

const setHcmOffset = () => {
    const offset = [...hcmNotices].reduce((total, notice) => total + notice.offsetHeight, 0);
    document.documentElement.style.setProperty('--hcm-offset', offset + 'px');
};

if (hcmNotices.length) {
    setHcmOffset();
    hcmNotices.forEach((notice) => {
        new MutationObserver(setHcmOffset).observe(notice, {
            attributes: true,
            attributeFilter: ['style', 'class'],
        });
    });
    window.addEventListener('resize', setHcmOffset, { passive: true });
}

update();
window.addEventListener('scroll', update, { passive: true });
window.addEventListener('resize', update, { passive: true });


// =============================================================================
/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false

// Abstracted event action handler
const doFancyboxOiEvent = (fancybox) => {
    let oi_event_name = false
    // Identify the proper event name. Use the first occurence from the possibilities
    // below.
    // 1. If a trigger element is available, use the value of data-oi-event-name when
    //    present. This is the most common scenario.
    // 2. If the Fancybox options object has oiEventName attribute, use the value. Event
    //    names are define this way when Fancybox assets are populated by a javascript
    //    array, and not DOM elements are available to place the data attribute.
    if (fancybox.options.$trigger
        && fancybox.options.$trigger.dataset
        && fancybox.options.$trigger.dataset.oiEventName) {
            oi_event_name = fancybox.options.$trigger.dataset.oiEventName
    }
    if (oi_event_name) {
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Define Fancybox config
window.FANCYBOX_CONFIG = {
    on: {
        initCarousel: (fancybox) => {
            if(!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if(!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
}

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", FANCYBOX_CONFIG)

/* END FANCYBOX */

// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function () {
  oi.utils.wrap_oi_aspect();
}, false);

function add_accessible_class(e) {
    if (e.keyCode === 9) {
        window.document.body.classList.add("accessible")
        window.removeEventListener("keyup", add_accessible_class)
    }
}
window.addEventListener("keyup", add_accessible_class)

const A11Y_TOGGLE_FILTERS = ".oi-map-nearby-filter, .oi-isp-filter-item";
const A11Y_ACTIVATABLE = '.oi-isp-point[role="button"], [data-hcm-policy-action][role="button"]';

document.addEventListener("click", (event) => {
    if (!event.target.closest(A11Y_TOGGLE_FILTERS)) return;
    document.querySelectorAll(A11Y_TOGGLE_FILTERS).forEach((filter) => {
        filter.setAttribute("aria-pressed", filter.classList.contains("active") ? "true" : "false");
    });
});

document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    const target = event.target.closest(A11Y_ACTIVATABLE);
    if (!target) return;
    event.preventDefault();
    target.click();
});

const contrast_btn = document.getElementById("contrast-btn");
const contrast_stylesheet = document.getElementById("a11y");

function set_contrast_state(is_on) {
    contrast_stylesheet.disabled = !is_on;
    contrast_btn.setAttribute("aria-pressed", is_on ? "true" : "false");
    const state = contrast_btn.querySelector(".contrast-btn-state");
    if (state) {
        state.textContent = is_on ? "On" : "Off";
        state.classList.toggle("btn-on", is_on);
        state.classList.toggle("btn-off", !is_on);
    }
}

if (contrast_btn && contrast_stylesheet) {
    contrast_btn.addEventListener("click", () => {
        const turning_on = contrast_stylesheet.disabled;
        if (turning_on) {
            oi.utils.cookie.set("a11y", "true");
        } else {
            oi.utils.cookie.delete("a11y", "true");
        }
        set_contrast_state(turning_on);
    });

    window.addEventListener("oilib_loaded", () => {
        set_contrast_state(Boolean(oi.utils.cookie.get("a11y", "true")));
    });
}

document.querySelectorAll(".form-group-message").forEach((message, index) => {
    const group = message.parentElement;
    if (!group) {
        return;
    }
    const controls = group.querySelectorAll("input:not([type=hidden]), select, textarea");
    if (!controls.length) {
        return;
    }
    if (!message.id) {
        message.id = `form-group-message-${index + 1}`;
    }
    controls.forEach((control) => {
        const described = (control.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
        if (!described.includes(message.id)) {
            described.push(message.id);
            control.setAttribute("aria-describedby", described.join(" "));
        }
    });
});

document.querySelectorAll("[data-hcm-policy-action]").forEach((action) => {
    if (action.getAttribute("role") === "button") {
        return;
    }
    action.setAttribute("role", "button");
    action.setAttribute("tabindex", "0");
});

document.querySelectorAll(".oi-hcm-notice-header, .oi-ccpa-notice-header").forEach((header) => {
    header.setAttribute("aria-level", "2");
});

window.oiNameMapMarkers = function (map_id) {
    const oimap = oi.loaded.map && oi.loaded.map[map_id];
    if (!oimap || !oimap.markers) {
        return;
    }
    oimap.markers.forEach((marker) => {
        if (typeof marker.setTitle !== "function" || marker.getTitle()) {
            return;
        }
        const item = document.querySelector('[data-listing-type][data-listing-id="' + marker.listing_id + '"]');
        if (!item) {
            return;
        }
        const label = item.querySelector(".oi-infowindow-header")
            || [...item.querySelectorAll("h1,h2,h3,h4,h5,h6")].find((h) => h.textContent.trim());
        const name = label ? label.textContent.replace(/\s+/g, " ").trim() : "";
        if (name) {
            marker.setTitle(name);
        }
    });
};

window.addEventListener("oi.loaded.map.oi-map", () => {
    let attempts = 0;
    const name_when_ready = () => {
        const oimap = oi.loaded.map && oi.loaded.map["oi-map"];
        if (oimap && oimap.markers && oimap.markers.length) {
            window.oiNameMapMarkers("oi-map");
            return;
        }
        attempts += 1;
        if (attempts < 20) {
            setTimeout(name_when_ready, 250);
        }
    };
    name_when_ready();
});
